import clsx from "clsx";
import React from "react";
export var PreviewAction = function (_a) {
    var children = _a.children, verticallyCentered = _a.verticallyCentered, visible = _a.visible, handleClick = _a.onClick;
    return (React.createElement("button", { onClick: handleClick, className: clsx("absolute flex rounded-full text-white text-center z-10 text-small bg-button", verticallyCentered && "-mt-2", visible ? "opacity-100" : "opacity-0"), style: { width: "2rem", height: "2rem", right: 4 } }, children));
};
